import { render, staticRenderFns } from "./AcademicRecordsForm.vue?vue&type=template&id=e7aef274&scoped=true&"
import script from "./AcademicRecordsForm.vue?vue&type=script&lang=js&"
export * from "./AcademicRecordsForm.vue?vue&type=script&lang=js&"
import style0 from "./AcademicRecordsForm.vue?vue&type=style&index=0&id=e7aef274&lang=scss&scoped=true&"
import style1 from "./AcademicRecordsForm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7aef274",
  null
  
)

export default component.exports